import { FormEvent, useContext, useEffect, useState } from 'react'
import { Button, Loader } from '../Styles'
import { ModalEstadoContext } from '../../contexts/ModalEstado';
import { membrosResponsaveis, paramsDesafio } from '../../interfaces/desafios';
import { toast } from 'react-toastify';
import { atualizarDesafio, cadastrarDesafio } from '../../services/desafios';
import { criptografarDado, descriptografarDado } from '../../helpers';
import { listarMembrosProjeto } from '../../services/projetos';
import { useLocation } from 'react-router-dom';

function ModalDesafio({ desafio, onClose }: paramsDesafio) {
  const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)
  
  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto")
  const usuarioExterno = localStorage.getItem("usuarioProjeto")

  const [processando, setProcessando] = useState(false);
  const [titulo, setTitulo] = useState(desafio?.titulo || "");
  const [situacao, setSituacao] = useState(desafio?.situacao || "");
  const [responsaveis, setResponsaveis] = useState<membrosResponsaveis[]>([]);
  const [responsavel, setResponsavel] = useState(desafio?.idResponsavel || "");
  const [descricao, setDescricao] = useState(desafio?.descricao || "");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)
    try {
      if (!idProjeto) return toast.error("Projeto não encontrado");

      const payload = {
        idProjeto: descriptografarDado(idProjeto), idResponsavel: responsavel, titulo, descricao
      }
      const resposta = await cadastrarDesafio(payload)

      if (resposta.status === 201) {
        setProcessando(false);
        atualizarDados()
        toast.success("Desafio Criado com Sucesso.")
        modalExibir("")
      }
    } catch (error) {
      setProcessando(false)
      toast.error("Erro ao Cadastrar Desafio.")
    }
  }

  const handleUpdate = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)
    try {
      if (!desafio?.id) return toast.error("Desafio não encontrado");
      if (!responsavel || !situacao || !titulo || !descricao) return toast.error("Preencha os Campos Obrigatórios.");

      const payload = {
        idResponsavel: responsavel, situacao, titulo, descricao
      }

      const resposta = await atualizarDesafio(criptografarDado(desafio.id.toString()), payload)

      if (resposta.status === 200) {
        setProcessando(false);
        toast.success("Desafio Atualizado com Sucesso.")
        atualizarDados()
        modalExibir("")
      }
    } catch (error: any) {
      if (error.status === 409) {
        setProcessando(false)
        return toast.warn("Desafio não pode ser alterado com a situação Executando ou Superado.")
      }
      setProcessando(false)
      toast.error("Erro ao Atualizar Desafio.")
    }
  }

  useEffect(() => {
    const listarMembrosResponsaveis = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

      try {
        const idProjetoEncoded = encodeURIComponent(idProjeto)
        const resposta = await listarMembrosProjeto(idProjetoEncoded);
        if (resposta.status === 200) {
          return setResponsaveis(resposta.data)
        }
      } catch (error) {
        toast.error("Erro ao listar todos os membros do Projeto.");
      }
    };
    listarMembrosResponsaveis()

  }, [idProjeto])

  return (
    <div id='fundoModal'>
      <section className={'containerModalCentro'}>
        <span className='novoContainerTitulo'>
          {desafio ? <h1>Atualizar DesaFio</h1> : <h1>Cadastrar DesaFio</h1>}
        </span>

        <form className="formModalNovo" onSubmit={(e) => desafio ? handleUpdate(e) : handleSubmit(e)}>
          <section>
            <span>
              <label htmlFor="">Titulo</label>
              <input type="text" placeholder='Digite o titulo do Desafio' onChange={(e) => { setTitulo(e.target.value) }} defaultValue={desafio?.titulo} required />
            </span>
          </section>
          <section>
            {desafio && <span>
              <label htmlFor="">Situação</label>
              <select name="" id="" onChange={(e) => { setSituacao(e.target.value) }} defaultValue={desafio?.situacao} disabled={desafio?.situacao ? false : true}>
                <option value="Mapeando">Mapeando</option>
                <option value="Estruturando">Estruturando</option>
                <option value="Executando">Executando</option>
                <option value="Superado">Superado</option>
              </select>
            </span>}
          </section>
          <section>
            <span>
              <label htmlFor="">Responsável</label>
              <select name="" id="" onChange={(e) => { setResponsavel(e.target.value) }} value={responsavel} required>
                <option value="" disabled>Selecione um Responsavel</option>
                {responsaveis.map((responsavel) => (
                  <option value={responsavel.usuario.id} key={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                ))}
              </select>
            </span>
          </section>
          <section>
            <span>
              <label htmlFor="">Descrição</label>
              <textarea rows={10} cols={45} className='areaTexto' onChange={(e) => { setDescricao(e.target.value) }} placeholder='Digite a Descrição' defaultValue={desafio?.descricao} required></textarea>
            </span>
          </section>
          <span className="botoesContainer">
            <Button type="button" cor="cancelar" isLoading={processando} onClick={() => { onClose() }}>
              Cancelar
            </Button>
            {!usuarioExterno && <Button type="submit" cor="salvar" isLoading={processando}>
              {!processando && "Salvar"}
              {processando && <Loader isLoading={processando} />}
            </Button>}
          </span>
        </form>
      </section>
    </div>
  )
}

export default ModalDesafio